import { style } from '@vanilla-extract/css';

export const floatingMenu = style({
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,

  transition: 'opacity 0.2s',
  willChange: 'transform',
});
